<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent2">Most of my research was carried out at the Regenstein Library of the University of Chicago, as well as at the Harold Washington Library in downtown Chicago. My thanks to the staffs at both places. And big thankyous to Ben Gibson and Ryan Finn at The History Press for steering this book through to publication.</p>
<p class="indent">My wife, Terri Schmidt, has been her usual wise, witty and patient self during my work. I have already dedicated four books to her, because she deserves it. But this time, the dedication will be to my two other favorite people in the world: my adult children, Nick Schmidt and Tracy Samantha Schmidt.</p>
<p class="noindent1">A.M.D.G.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?1a169e82